import React, { useState } from "react";
import { motion } from "framer-motion";
import "../styles/card.css";
// import pic from "../img/portrait.jpg";
// import { Link } from "react-router-dom";

// const mobileCardMotion = {
//   name: "mobileCardMotion",
//   rest: {
//     // height: "100%",
//     // width: 0,
//     opacity: 0,
//     width: "100%",
//   },
//   hover: {
//     // width: 450,
//     opacity: 1,
//     transition: {
//       duration: 0.5,
//       type: "spring",
//     },
//   },
//   tap: {
//     // width: 450,
//     opacity: 1,
//     transition: {
//       duration: 0.5,
//       type: "spring",
//     },
//   },
//   animate: {
//     opacity: 1,
//     transition: {
//       duration: 0.5,
//       type: "spring",
//     },
//   },
// };
const cardMotion = {
  name: "cardMotion",
  rest: {
    height: "100%",
    width: 0,
  },
  hover: {
    width: 450,
    transition: {
      duration: 0.5,
      type: "spring",
    },
  },
  tap: {
    width: 450,
    transition: {
      duration: 0.5,
      type: "spring",
    },
  },
  animate: {
    height: "100%",
    width: 0,
  },
};
const insideContentMotion = {
  rest: {
    x: -500,
    opacity: 0,
  },
  hover: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 0.2,
    },
  },
  tap: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 0.2,
    },
  },
};
const nameMotion = {
  rest: {
    x: -500,
    opacity: 0,
  },
  hover: {
    opacity: 1,
    x: 0,
    transition: { type: "spring", stiffness: 90 },
  },
  tap: {
    opacity: 1,
    x: 0,
    transition: { type: "spring", stiffness: 90 },
  },
};
const descriptionMotion = {
  rest: {
    // x: -500,
    opacity: 0,
  },
  hover: {
    opacity: 1,
    // x: 0,
    transition: {
      delay: 0.8,
    },
  },
  tap: {
    opacity: 1,
    // x: 0,
    transition: {
      delay: 0.8,
    },
  },
};
const socialMediaVariant = {
  start: {
    width: 21,
    height: 21,
    x: 0,
  },
  onHover: {
    width: 25,
    height: 25,
    x: 0,
    // fill: 'white',
  },
  tap: {
    width: 25,
    height: 25,
    x: 0,
  },
};
const socialMediaNameVariant = {
  start: {
    scale: 1,
    x: 0,
  },
  onHover: {
    scale: 1.4,
    x: 20,
    originX: 0,
    // color: 'white',
  },
  tap: {
    scale: 1.4,
    x: 20,
    originX: 0,
    // color: 'white',
  },
};
const pathVariant = {
  start: {
    // fill: '#000',
  },
  onHover: {
    // fill: '#fff',
  },
};
const Card = ({
  name,
  image,
  skill,
  position,
  classStudying,
  year,
  linkedin,
  github,
  facebook,
  instagram,
}) => {
  const [mobile, setMobile] = useState(false);
  // console.log(image);
  // const [motionVariant, setMotionVariant] = useState(cardMotion);

  // const handleResize = () => {
  //   // console.log(window.innerWidth);
  //   console.log(motionVariant);
  //   if (window.innerWidth < 768) {
  //     setMotionVariant(mobileCardMotion);
  //     // console.log("Set to mobile");
  //   }
  //   if (window.innerWidth > 768) {
  //     setMotionVariant(cardMotion);
  //     // console.log("Set to Desktop");
  //   }
  // };
  // window.addEventListener("resize", handleResize);
  // // useEffect(() => {
  // //   return (_) => window.removeEventListener("resize", handleResize);
  // // }, []);

  const svgHeight = 20;
  const svgWidth = 20;

  return (
    <motion.div
      className="
       card
       relative
       overflow-visible
       flex
       flex-col
       md:flex-row
       m-3
       "
      // variants={cardVariant}
      initial="rest"
      whileHover="hover"
      // onTap="tap"
      animate={mobile ? "hover" : "animate"}
      onClick={() => {
        if (mobile) {
          setMobile(false);
        } else {
          setMobile(true);
        }
      }}
    >
      <motion.div
        className="
      image
      absolute
      w-full
      md:h-full
      md:w-60
      md:relative
      md:rounded-3xl
      overflow-hidden
      flex
      items-center
      "
      >
        <img
          className="
            object-cover
            w-full
            md:w-60
            h-full
            overflow-hidden
            object-top
          "
          src={image}
          alt=""
        />
      </motion.div>
      <motion.div
        className="
      content
      flex
      overflow-hidden
      h-1/2
      md:h-full
      md:relative
      md:-ml-12
      md:rounded-3xl
      
      "
        variants={cardMotion}
      >
        <motion.div
          className="
        information
        absolute
        my-2
        md:my-5
        ml-6
        md:ml-20
        mr-2
        text-current
        dark:text-white
        "
          variants={insideContentMotion}
        >
          <motion.h1
            className="
            text-current
            mb-1
            md:mb-3
            font-medium
            text-2xl
            md:text-4xl
            relative
          "
            variants={nameMotion}
          >
            {name}
          </motion.h1>
          <motion.div variants={descriptionMotion}>
            <h3
              className="
              text-role
              text-current
              text:sm
              md:text-xl
              font-normal
              mt-1
              md:mt-2
            "
            >
              {skill}
            </h3>
            <span
              className="
            position
            text-current
            font-thin
            italic
            text-sm

            "
            >
              {position}
            </span>
            <span
              className="
            class
            block
            text-current
            mt-1
            md:mt-3
            font-normal
            text-sm
            md:text-lg
            "
            >
              {classStudying}
            </span>
            <span
              className="
            year
            block
            text-current
            italic
            text-xs
            font-thin
            "
            >
              {year}
            </span>
            <div className="social-media">
              <div
                className="
              visit-on
              text-sm
              md:text-lg
              mt-1
              mb-1
              font-meduim
              relative
              "
              >
                Visit On:
              </div>
              <motion.ul
                className="
              social-media-icons
              list-none
              no-underline
              "
              >
                {linkedin && (
                  <a href={linkedin} target="blank" rel="noopener noreferrer">
                    <motion.li
                      className="
                  flex
                  flex-row
                  items-center
                  mx-1
                  my-1
                  ml-1
                  mt-1
                  cursor-pointer
                  "
                      initial="start"
                      whileHover="onHover"
                      animate="start"
                    >
                      <motion.svg
                        variants={socialMediaVariant}
                        width={svgWidth}
                        height={svgHeight}
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <motion.path
                          variants={pathVariant}
                          d="M20.2732 -0.0488281H1.72732C0.746708 -0.0488281 -0.0488281 0.746708 -0.0488281 1.72732V20.2732C-0.0488281 21.2538 0.746708 22.0494 1.72732 22.0494H20.2732C21.2539 22.0494 22.0494 21.2538 22.0494 20.2732V1.72732C22.0494 0.746708 21.2539 -0.0488281 20.2732 -0.0488281ZM20.2732 20.2815C7.90377 20.2788 1.71903 20.276 1.71903 20.2732C1.72179 7.90377 1.72455 1.71903 1.72732 1.71903C14.0968 1.72179 20.2815 1.72455 20.2815 1.72732C20.2788 14.0968 20.276 20.2815 20.2732 20.2815ZM3.22723 8.23524H6.50605V18.7816H3.22723V8.23524ZM4.86802 6.79333C5.91493 6.79333 6.76847 5.94255 6.76847 4.89288C6.76847 4.64331 6.71932 4.39619 6.62381 4.16562C6.5283 3.93504 6.38832 3.72554 6.21184 3.54907C6.03537 3.37259 5.82587 3.23261 5.59529 3.1371C5.36472 3.04159 5.11759 2.99244 4.86802 2.99244C4.61845 2.99244 4.37133 3.04159 4.14076 3.1371C3.91018 3.23261 3.70068 3.37259 3.52421 3.54907C3.34773 3.72554 3.20775 3.93504 3.11224 4.16562C3.01673 4.39619 2.96758 4.64331 2.96758 4.89288C2.96482 5.94255 3.8156 6.79333 4.86802 6.79333ZM11.8372 13.5637C11.8372 12.1881 12.0997 10.8566 13.804 10.8566C15.4835 10.8566 15.5083 12.4284 15.5083 13.6521V18.7816H18.7844V12.9974C18.7844 10.1578 18.1712 7.97282 14.8537 7.97282C13.2598 7.97282 12.1908 8.84846 11.7516 9.67715H11.7074V8.23524H8.56119V18.7816H11.8372V13.5637Z"
                          fill="#06062D"
                        />
                      </motion.svg>
                      <motion.span variants={socialMediaNameVariant}>
                        LinkedIn
                      </motion.span>
                    </motion.li>
                  </a>
                )}
                {github && (
                  <a href={github} target="blank" rel="noopener noreferrer">
                    <motion.li
                      className="
                  flex
                  flex-row
                  items-center
                  mx-1
                  my-1
                  ml-1
                  mt-1
                  cursor-pointer
                  "
                      initial="start"
                      whileHover="onHover"
                      animate="start"
                    >
                      <motion.svg
                        variants={socialMediaVariant}
                        width={svgWidth}
                        height={svgHeight}
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <motion.path
                          variants={pathVariant}
                          d="M11.0012 9.45395e-07C4.92303 -0.00252373 0 5.05187 0 11.2903C0 16.2235 3.07966 20.417 7.36856 21.9571C7.94615 22.106 7.85767 21.6844 7.85767 21.3966V19.44C4.5224 19.8414 4.38722 17.5742 4.16356 17.1955C3.71132 16.4028 2.64216 16.2008 2.96168 15.8221C3.72115 15.4207 4.49536 15.9231 5.39247 17.2839C6.04134 18.2711 7.30712 18.1044 7.94861 17.9403C8.08871 17.347 8.38856 16.8168 8.80148 16.4053C5.34577 15.7691 3.90549 13.6029 3.90549 11.0278C3.90549 9.77806 4.30611 8.62933 5.09262 7.70278C4.59122 6.17535 5.13931 4.86757 5.21305 4.67317C6.64105 4.54189 8.12557 5.72343 8.24109 5.81685C9.05217 5.59215 9.97877 5.47349 11.016 5.47349C12.0581 5.47349 12.9872 5.5972 13.8056 5.82442C14.0833 5.6073 15.4597 4.59238 16.787 4.71609C16.8582 4.91049 17.394 6.18797 16.9221 7.6952C17.7185 8.62428 18.124 9.78311 18.124 11.0353C18.124 13.6156 16.6739 15.7843 13.2084 16.4104C13.5052 16.7102 13.7409 17.0678 13.9017 17.4623C14.0624 17.8568 14.1451 18.2802 14.1448 18.7078V21.5481C14.1645 21.7753 14.1448 22 14.5135 22C18.8663 20.4928 22 16.269 22 11.2929C22 5.05187 17.0745 9.45395e-07 11.0012 9.45395e-07Z"
                          fill="#06062D"
                        />
                      </motion.svg>
                      <motion.span variants={socialMediaNameVariant}>
                        Github
                      </motion.span>
                    </motion.li>
                  </a>
                )}
                {facebook && (
                  <a href={facebook} target="blank" rel="noopener noreferrer">
                    <motion.li
                      className="
                  flex
                  flex-row
                  items-center
                  mx-1
                  my-1
                  ml-1
                  mt-1
                  cursor-pointer
                  "
                      initial="start"
                      whileHover="onHover"
                      animate="start"
                    >
                      <motion.svg
                        variants={socialMediaVariant}
                        width={svgWidth}
                        height={svgHeight}
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <motion.path
                          variants={pathVariant}
                          d="M21.1655 -0.0488281H0.8351C0.346177 -0.0488281 -0.0488281 0.346177 -0.0488281 0.8351V21.1655C-0.0488281 21.6544 0.346177 22.0494 0.8351 22.0494H21.1655C21.6544 22.0494 22.0494 21.6544 22.0494 21.1655V0.8351C22.0494 0.346177 21.6544 -0.0488281 21.1655 -0.0488281ZM20.2815 20.2815H15.1962V13.4919H18.0689L18.4999 10.1578H15.1962V8.02807C15.1962 7.06127 15.4641 6.40385 16.848 6.40385H18.6131V3.42059C18.3065 3.37916 17.2596 3.288 16.0387 3.288C13.4919 3.288 11.7489 4.84316 11.7489 7.69659V10.155H8.87056V13.4891H11.7516V20.2815H1.71903V1.71903H20.2815V20.2815Z"
                          fill="#06062D"
                        />
                      </motion.svg>
                      <motion.span variants={socialMediaNameVariant}>
                        Facebook
                      </motion.span>
                    </motion.li>
                  </a>
                )}
                {instagram && (
                  <a href={instagram} target="blank" rel="noopener noreferrer">
                    <motion.li
                      className="
                  flex
                  flex-row
                  items-center
                  mx-1
                  my-1
                  ml-1
                  mt-1
                  cursor-pointer
                  "
                      initial="start"
                      whileHover="onHover"
                      animate="start"
                    >
                      <motion.svg
                        variants={socialMediaVariant}
                        width={svgWidth}
                        height={svgHeight}
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <motion.path
                          variants={pathVariant}
                          d="M11.0011 5.30379C7.84888 5.30379 5.30492 7.84775 5.30492 10.9999C5.30492 14.1521 7.84888 16.6961 11.0011 16.6961C14.1532 16.6961 16.6972 14.1521 16.6972 10.9999C16.6972 7.84775 14.1532 5.30379 11.0011 5.30379ZM11.0011 14.702C8.96256 14.702 7.29898 13.0384 7.29898 10.9999C7.29898 8.96142 8.96256 7.29785 11.0011 7.29785C13.0396 7.29785 14.7031 8.96142 14.7031 10.9999C14.7031 13.0384 13.0396 14.702 11.0011 14.702ZM16.9305 3.74297C16.1945 3.74297 15.6002 4.33731 15.6002 5.07328C15.6002 5.80925 16.1945 6.40358 16.9305 6.40358C17.6665 6.40358 18.2608 5.81202 18.2608 5.07328C18.261 4.89852 18.2267 4.72543 18.16 4.56393C18.0932 4.40243 17.9952 4.2557 17.8716 4.13212C17.7481 4.00855 17.6013 3.91057 17.4398 3.84379C17.2783 3.77702 17.1052 3.74276 16.9305 3.74297ZM22.1045 10.9999C22.1045 9.46688 22.1184 7.94773 22.0323 6.41746C21.9462 4.64003 21.5407 3.06255 20.241 1.7628C18.9384 0.460267 17.3637 0.0575667 15.5863 -0.028528C14.0533 -0.114623 12.5341 -0.100736 11.0038 -0.100736C9.47079 -0.100736 7.95164 -0.114623 6.42137 -0.028528C4.64393 0.0575667 3.06646 0.463045 1.7667 1.7628C0.464174 3.06533 0.061473 4.64003 -0.0246217 6.41746C-0.110716 7.95051 -0.0968302 9.46966 -0.0968302 10.9999C-0.0968302 12.5302 -0.110716 14.0521 -0.0246217 15.5824C0.061473 17.3598 0.466951 18.9373 1.7667 20.2371C3.06923 21.5396 4.64393 21.9423 6.42137 22.0284C7.95442 22.1145 9.47357 22.1006 11.0038 22.1006C12.5369 22.1006 14.056 22.1145 15.5863 22.0284C17.3637 21.9423 18.9412 21.5368 20.241 20.2371C21.5435 18.9345 21.9462 17.3598 22.0323 15.5824C22.1212 14.0521 22.1045 12.533 22.1045 10.9999ZM19.6605 17.5487C19.4578 18.0541 19.2134 18.4318 18.8218 18.8207C18.4302 19.2122 18.0553 19.4566 17.5498 19.6594C16.089 20.2398 12.6202 20.1093 11.0011 20.1093C9.38192 20.1093 5.91036 20.2398 4.44953 19.6622C3.94407 19.4594 3.56636 19.215 3.17755 18.8234C2.78595 18.4318 2.54156 18.0569 2.33882 17.5515C1.76115 16.0878 1.89168 12.6191 1.89168 10.9999C1.89168 9.38079 1.76115 5.90923 2.33882 4.4484C2.54156 3.94294 2.78595 3.56523 3.17755 3.17642C3.56914 2.7876 3.94407 2.54043 4.44953 2.33769C5.91036 1.76002 9.38192 1.89055 11.0011 1.89055C12.6202 1.89055 16.0918 1.76002 17.5526 2.33769C18.058 2.54043 18.4358 2.78482 18.8246 3.17642C19.2162 3.56801 19.4606 3.94294 19.6633 4.4484C20.241 5.90923 20.1104 9.38079 20.1104 10.9999C20.1104 12.6191 20.241 16.0878 19.6605 17.5487Z"
                          fill="#06062D"
                        />
                      </motion.svg>
                      <motion.span variants={socialMediaNameVariant}>
                        Instagram
                      </motion.span>
                    </motion.li>
                  </a>
                )}
              </motion.ul>
            </div>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Card;
